import type from './Supplier.type';

const initialState = {
  suppliersList: [],
  usersList: [],
  brands: [],
  categoryType1: [],
  categoryType2: [],
  componetSuppliers: [],
  totalRecords_ComponetSuppliers: 0,
  criticalPaths: [],
  supportingDocuments: [],
  pendingDocumentType: [],
  tier1List: [],
  productSupplier: [],
  tier2AndAboveList: [],
  factorySupplierList: [],
  allTierList: [],
  allSupplierTags: [],
  supplierTemplateById: {},
  supplierTemplates: [],
  documentTemplate: [],
  allPartnerOverviewTemplates: [],
  templateDetails: {},
  libraryPages: [],
  templateModulePageList: [],
  templateModulePageControlList: [],
  templateData: [],
  factoriesTags: [],
  tier2Suppliers: [],
  tier3Suppliers: [],
  tier4Suppliers: [],
  tier1Suppliers: [],
  calculationControlList: [],
  libraryCalculationPages: [],
  templateCalculationPages: [],
  supplierComponentFactory: [],
  singleSupplier: null,
  tier1SuppliersNewData: [],
  tier2SuppliersNewData: [],
  tier3SuppliersNewData: [],
  tier4SuppliersNewData: [],
};

const SuppliersReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.SUPPLIER_LIST:
      return {
        ...state,
        suppliersList: [...state.suppliersList, ...action.payload],
      };
    case type.GET_TIER1:
      return {
        ...state,
        tier1List: action.payload,
      };
    case type.GET_ALL_TIER:
      return {
        ...state,
        allTierList: action.payload,
      };
    case type.GET_PRODUCT_SUPPLIER:
      return {
        ...state,
        productSupplier: action.payload,
      };
    case type.GET_TIER2_ABOVE:
      return {
        ...state,
        tier2AndAboveList: action.payload,
      };
    case type.SUPPLIER_COMPONENT_FACTORY_LIST: {
      return {
        ...state,
        supplierComponentFactory: action.payload,
      };
    }
    case type.GET_FACTORY_SUPPLIERS:
      return {
        ...state,
        factorySupplierList: action.payload,
      };
    case type.DELETE_SUPPLIER:
      const list = state.suppliersList;
      const index = action.payload;
      list.splice(index, 1);
      return {
        ...state,
        suppliersList: list,
      };
    case type.UPDATE_SUPPLIER:
      const onedit = action?.payload?.length ? [...action.payload] : [];
      return {
        ...state,
        suppliersList: onedit,
      };

    case type.DELETE_USER:
      const listOfUsers = state.usersList;
      return {
        ...state,
        usersList: listOfUsers,
      };

    case type.SUPPLIER_COMPONENT_LIST:
      return {
        ...state,
        componetSuppliers: action.payload.doc,
        totalRecords_ComponetSuppliers: action.payload.totalCount,
      };
    case type.ONE_SUPPLIER_COMPONENT:
      return {
        ...state,
        singleSupplier: action.payload,
      };
    case type.ADD_SUPPLIER_COMPONENT:
      return {
        ...state,
        componetSuppliers: [...state.componetSuppliers, action.payload],
      };

    case type.UPDATE_COMPONENET_SUPPLIER:
      const { params, indexForEdit } = action.payload;
      const previousData = state.componetSuppliers;
      previousData[indexForEdit] = params;
      return {
        ...state,
        componetSuppliers: previousData,
      };
    case type.DELETE_SUPPLIER_COMPONENET:
      const componentList = state.componetSuppliers;
      const deleteIndex = action.payload;
      componentList.splice(deleteIndex, 1);
      return {
        ...state,
        componetSuppliers: componentList,
      };

    /*
     * Appends to a copy. The previous version only appended when the list was
     * already non-empty, so the first user added to an empty partner vanished
     * from the store until the next full fetch.
     */
    case type.ADD_USER: {
      return {
        ...state,
        usersList: [...(state.usersList ?? []), action.payload],
      };
    }
    case type.GET_USER:
      return {
        ...state,
        usersList: action.payload,
      };

    /*
     * Merges the edited fields into the matching user and returns a new array.
     * The previous version used `.find()`, which yields the matched ELEMENT,
     * so `usersList` was replaced by a single user object rather than a list;
     * it also assigned into `prvList[i]`, mutating store state in place, and
     * dropped `_id` because the payload carries only the submitted fields.
     * Callers papered over all three by refetching the whole list after every
     * save. Merging onto the existing record keeps fields the form does not
     * submit, such as `hasPassword`.
     */
    case type.EDIT_USER: {
      const { params: editedFields, id: editedId } = action.payload;
      return {
        ...state,
        usersList: (state.usersList ?? []).map((item) => (item?._id === editedId ? { ...item, ...editedFields } : item)),
      };
    }
    case type.DELETE_MULTI_USER:
      const removeIds = action.payload;
      const userlist = state.usersList.filter((item) => removeIds.indexOf(item._id) === -1);
      return {
        ...state,
        usersList: userlist,
      };
    case type.SET_BRAND_AND_CATEGORY_ASSIGMENT:
      const brandAndCategoryData = {
        ...state.brandAndCategoryAssignment,
        brands: action.payload,
      };

      return {
        ...state,
        brandAndCategoryAssignment: brandAndCategoryData,
      };

    case type.ALL_SUPPLIER_DOCUMENT_LIST:
      return {
        ...state,
        supportingDocuments: action.payload,
      };
    case type.DOCUMENT_LIST:
      const suppDocs = action.payload;
      return {
        ...state,
        supportingDocuments: suppDocs,
      };
    case type.ADD_DOCUMENT:
      let allDocuments = state.supportingDocuments;
      allDocuments = [...allDocuments, action.payload];
      return {
        ...state,
        supportingDocuments: allDocuments,
      };
    case type.DELTE_DOCUMENT:
      const currentDocuments = state.supportingDocuments;
      return {
        ...state,
        supportingDocuments: currentDocuments,
      };
    case type.DELETE_MULTI_DOCUMENTS:
      const IdsForDelete = action.payload;
      const { length } = IdsForDelete;
      const ind = state.supportingDocuments;
      ind.splice(0, length);
      return {
        ...state,
        supportingDocuments: ind,
      };
    case type.UPDATE_DOCUMENT:
      const prevDocumentList = state.supportingDocuments;
      const { documetnData, docId } = action.payload;
      const PreviousDoc = prevDocumentList.find((item, i) =>
        item._id === docId
          ? (prevDocumentList[i] = {
              ...prevDocumentList[i],
              title: documetnData.title,
            })
          : null,
      );
      return {
        ...state,
        supportingDocuments: PreviousDoc,
      };
    case type.DUE_DATES_LIST:
      return {
        ...state,
        criticalPaths: action.payload,
      };

    case type.DELETE_DUE_DATE:
      const cp = action.payload;
      return {
        ...state,
        criticalPaths: cp,
      };

    case type.FACTORY_CLEAR:
      return {
        ...state,
        componetSuppliers: [],
      };

    case type.BRANDS:
      return {
        ...state,
        brands: action.payload,
      };

    case type.CATEGORY1:
      return {
        ...state,
        categoryType1: action.payload,
      };

    case type.CATEGORY2:
      return {
        ...state,
        categoryType2: action.payload,
      };
    case type.CLEAR:
      return {
        ...state,
        supportingDocuments: [],
      };

    case type.CLEAR_USER_REDUCER: {
      const clearRed = action.payload;
      return {
        ...state,
        usersList: clearRed,
      };
    }

    case type.GET_PENDING_TYPE: {
      return {
        ...state,
        pendingDocumentType: action.payload,
      };
    }
    case type.SUPPLIER_TAGS: {
      return {
        ...state,
        allSupplierTags: action.payload.tags,
      };
    }
    case type.GET_SUPPLIER_TEMPLATE_BY_ID:
      return {
        ...state,
        supplierTemplateById: action.payload,
      };
    case type.GET_SUPPLIER_TEMPLATE:
      return {
        ...state,
        supplierTemplates: action.payload,
      };
    case type.UNMOUNT_LIBRARY:
      return {
        ...state,
        supplierTemplateById: {},
        templateDetails: {},
        templateModulePageList: [],
        templateModulePageControlList: [],
        templateData: [],
      };
    case type.GET_DOCUMENT_TEMPLATE:
      return {
        ...state,
        documentTemplate: action.payload,
      };
    case type.GET_ALL_TEMPLATE:
      return {
        ...state,
        allPartnerOverviewTemplates: action.payload,
      };
    case type.CLEAR_DATA:
      return {
        ...state,
        allPartnerOverviewTemplates: [],
      };
    case type.SOURCE_TEMPLATE:
      return {
        ...state,
        templateDetails: action.payload,
      };
    case type.LIBRARY_PAGES:
      return {
        ...state,
        libraryPages: action.payload,
      };
    /*
     * `pages` is consumed everywhere as an array (`.filter`, `.find`, `.length`).
     * The endpoint can return it as an unpopulated reference string instead —
     * `"pages_<templateId>"` — and `.filter` on a string threw, blanking the
     * whole template editor. Normalising here, the single point where the
     * payload enters the store, keeps every consumer on an array. Note this
     * only stops the crash: when the field arrives unpopulated the pages are
     * genuinely absent from the response and the editor renders empty.
     */
    case type.GET_PARTNER_MODULE_LIST: {
      const modulePayload = action.payload;
      return {
        ...state,
        templateModulePageList:
          modulePayload && typeof modulePayload === 'object' && !Array.isArray(modulePayload)
            ? { ...modulePayload, pages: Array.isArray(modulePayload.pages) ? modulePayload.pages : [] }
            : modulePayload,
      };
    }
    case type.GET_PARTNER_MODULE_PAGE_CONTROL_LIST:
      return {
        ...state,
        templateModulePageControlList: action.payload,
      };
    case type.SUPPLIER_PAGE_LIST:
      return {
        ...state,
        templateData: action.payload,
      };
    case type.GET_PARTNER_MODULE_DEPENDENT_CONTROL_LIST:
      return {
        ...state,
        partnerModuleDependentControls: action.payload,
      };
    case type.FACTORIES_TAGS: {
      return {
        ...state,
        factoriesTags: action.payload.tags,
      };
    }
    case type.GET_SUPPTIER2: {
      return {
        ...state,
        tier2Suppliers: action.payload,
      };
    }
    case type.GET_SUPPTIER3: {
      return {
        ...state,
        tier3Suppliers: action.payload,
      };
    }
    case type.GET_SUPPTIER4: {
      return {
        ...state,
        tier4Suppliers: action.payload,
      };
    }
    case type.GET_SUPPTIER1: {
      return {
        ...state,
        tier1Suppliers: action.payload,
      };
    }
    case type.GET_PARTNER_PAGE_CALCULATION_CONTROL_LIST: {
      return {
        ...state,
        calculationControlList: action.payload,
      };
    }
    case type.CALCULATION_LIBRARY_PAGES:
      return {
        ...state,
        libraryCalculationPages: action.payload?.pages || [],
      };
    case type.GET_SUPPLIER_TEMPLATE_CALCULATION_PAGE:
      return {
        ...state,
        templateCalculationPages: action.payload,
      };
    case type.CLEAR_SINGLE_SUPPLIER:
      return {
        ...state,
        singleSupplier: null,
      };
    case type.GET_SUPPTIERTWO: {
      return {
        ...state,
        tier2SuppliersNewData: action.payload,
      };
    }
    case type.GET_SUPPTIERTHREE: {
      return {
        ...state,
        tier3SuppliersNewData: action.payload,
      };
    }
    case type.GET_SUPPTIERFOUR: {
      return {
        ...state,
        tier4SuppliersNewData: action.payload,
      };
    }
    case type.GET_SUPPTIERONE: {
      return {
        ...state,
        tier1SuppliersNewData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default SuppliersReducer;
